import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ProviderAuthState, ForgotPasswordType, LoginProviderFormType, ResendVerificationCodeType, VerifyProviderEmailType } from "./types";
import { ProviderModel } from "../../Services/Models/Auth/ProviderModels";
import { ProviderDashboardModel } from "../../Services/Models/Auth/ProviderModels";
import { VerifyEmailResponseType } from "./types";

type loadings = {
  loading: boolean;
  resetPassLoading: boolean;
};
type InitialAuthState = Pick<ProviderAuthState, "isLoggedIn" | "isVerified" | "user" | "isConfirmEmail"> & loadings;
const initialState: InitialAuthState = {
  loading: false,
  resetPassLoading: false,
  isLoggedIn: false,
  isVerified: false,
  user: undefined,
  isConfirmEmail: false,
};

const providerSlice = createSlice({
  name: "provider",
  initialState,
  reducers:{
    loginRequest: (state: InitialAuthState, action: PayloadAction<LoginProviderFormType>) => {
      state.loading = true;
    },
    loginSuccess: (state: InitialAuthState, action: PayloadAction<ProviderModel>) => {
      state.loading = false;
      state.isConfirmEmail = false;
      state.user = action.payload;
      state.isLoggedIn = true;
    },
    loginFailed(state: InitialAuthState) {
      state.loading = false;
      state.isLoggedIn = false;
    },
    loginFailedWithVerificationError: (state: InitialAuthState) => {
      state.loading = false;
      state.isConfirmEmail = true;
    },
    logout(state: InitialAuthState) {
      state = initialState
    },
    // Verify Email
    verifyEmail(state: InitialAuthState, action: PayloadAction<VerifyProviderEmailType>){
      state.loading = true;
    },
    verifyEmailSuccess(state: InitialAuthState, action: PayloadAction<VerifyEmailResponseType>){
      state.user = action.payload.data;
      state.isLoggedIn = true;
      state.isVerified = true;
      state.loading = false;
      state.isConfirmEmail = false;
    },
    verifyEmailFailed(state: InitialAuthState, action: PayloadAction<string>){
      state.loading = false;
      state.isVerified = false;
      state.isLoggedIn = false;
    },
    resendEmailVerificationCodeRequest(state: InitialAuthState, action: PayloadAction<ResendVerificationCodeType>){
      state.loading = true;
      if(action.payload.verifyFor === "forgot"){
        state.isConfirmEmail = true;
      }
    },
    resendEmailVerificationCodeRequestComplete: (state: InitialAuthState) => {
      state.loading = false;
    },
    updateAuthUserOnVerify(state: InitialAuthState, action: PayloadAction<ProviderModel>){
      state.user = action.payload;
    },
    // Profile Details
    updateProviderProfileRequest: (state: InitialAuthState, action: PayloadAction<any>) => {
      state.loading = true;
    },
    updateProviderProfileSuccess: (state: InitialAuthState, action: PayloadAction<any>) => {
      state.loading = false;
      state.user = {...state.user, ...action.payload};
    },
    updateProviderProfileFail: (state: InitialAuthState) => {
      state.loading = false;
    },
    //password
    resetPasswordRequest:(state: InitialAuthState, action: PayloadAction<{currentPassword: string, newPassword: string}>)=>{
      state.resetPassLoading = true;
    },
    resetPasswordSuccess: (state: InitialAuthState) => {
      state.resetPassLoading = false;
    },
    resetPasswordFail: (state: InitialAuthState) => {
      state.resetPassLoading = false;
    },
    // Dashboard Alert
    updateDashboardRequest(state: InitialAuthState, action: PayloadAction<ProviderDashboardModel>){
      state.loading = false;
    },
    updateDashboardSuccess(state: InitialAuthState, action: PayloadAction<ProviderDashboardModel>){
      state.loading = false;
    },
    updateDashboardFail(state: InitialAuthState, action: PayloadAction<string>){
      state.loading = false;
    },
    forgotPassword: (state: InitialAuthState, action: PayloadAction<ForgotPasswordType>) => {
      state.loading = true
    },
    forgotPasswordSuccess: (state: InitialAuthState) => {
      state.loading = false;
      state.isConfirmEmail = false;
    },
    forgotPasswordFailed: (state: InitialAuthState) => {
      state.loading = false;
      state.isConfirmEmail = false;
    },
    setProviderLoading: (state: InitialAuthState) => {
      state.loading = true;
    },
    unsetProviderLoading: (state: InitialAuthState) => {
      state.loading = false;
    }
  }
});

export const providerActions = providerSlice.actions;

// Reducer
const providerReducer = providerSlice.reducer;
export default providerReducer;